<template>
  <div>
    <ok-cancel-modal
      :title="$t('health.explorer.multipleBoard.selectUsers')"
      :ok-button="$t('commons.ok')"
      :cancel-button="$t('commons.cancel')"
      v-on:ok="onOk()"
      v-on:cancel="$emit('close')">
      <div
        slot="body">
        <search-input
          class="search-input"
          v-on:input="onChangeFilter"/>
        <div
          class="margin-top-xl food-list">
          <checkbox
            v-for="(user, index) in getFilteredOptions.slice(0, maxUsersToShow)"
            :key="index"
            :disabled="(chosenUsers.length >= maxSelectedUsers) && !isChecked(user)"
            class="margin-right-s"
            v-on:change="onUserSelected(user)"
            :checked="isChecked(user)"
            :label="user.label"
            :id="String(user.id)"
            check-size="m"/>
          <div
            v-if="getFilteredOptions.length > maxUsersToShow"
            class="and-x-more">
            {{ $t('variables.andXMore', {count: usersToShow()}) }}
          </div>
        </div>
      </div>
    </ok-cancel-modal>
  </div>
</template>

<script>
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';
import Checkbox from '@/components/shared/forms/Checkbox';
import SearchInput from '@/components/shared/SearchInput';
import GridRow from '../../../../components/shared/grid/GridRow';

export default {
  name: 'MultipleUserSelector',
  components: {
    GridRow,
    OkCancelModal,
    Checkbox,
    SearchInput
  },
  props: {
    maxUsersToShow: {
      type: Number,
      default: 10
    },
    maxSelectedUsers: {
      type: Number,
      default: 4
    },
    options: {
      type: Array,
      default: () => []
    },
    selectedUsers: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      usersFilter: '',
      chosenUsers: []
    };
  },
  created () {
    this.chosenUsers = this.selectedUsers;
  },
  computed: {
    getFilteredOptions () {
      if (this.usersFilter !== '') {
        return this.options.filter(user => {
          return user.label.toUpperCase().includes(this.usersFilter.toUpperCase());
        });
      }
      return this.options;
    }
  },
  methods: {
    onOk () {
      this.$emit('input', this.chosenUsers);
      this.$emit('close');
    },
    onChangeFilter (filter) {
      this.usersFilter = filter;
    },
    usersToShow () {
      return this.getFilteredOptions.length - this.maxUsersToShow;
    },
    onUserSelected (user) {
      if (this.isChecked(user)) {
        this.chosenUsers = this.chosenUsers.filter(selectedUser => selectedUser.id !== user.id);
      } else {
        this.chosenUsers.push(user);
      }
    },
    isChecked (user) {
      const matchingUser = this.chosenUsers.find(selectedUser => selectedUser.id === user.id);
      return matchingUser !== undefined;
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/brand/health/components/explorer/MultipleUserSelector.vue